import { useContext } from 'react';
import { MotionContext, type MotionContextValue } from './MotionProvider';

export function useMotion(): MotionContextValue {
  const ctx = useContext(MotionContext);
  if (!ctx) throw new Error('useMotion must be used inside <MotionProvider>');
  return ctx;
}
